import { Link } from "react-router-dom";
import { Tv } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-16 bg-[#05070a] border-t-4 border-[#ff2fa7] shadow-[0_-2px_10px_rgba(57,255,20,0.1)]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid md:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <div className="bg-pink-500 border-4 border-yellow-300 rounded-2xl p-2">
              <Tv className="w-6 h-6 text-white" strokeWidth={3} />
            </div>
            <div className="font-display font-black text-2xl text-yellow-300">DESENE2000</div>
          </div>
          <p className="text-white/80 text-sm leading-relaxed">
            Cea mai tare colecție de desene animate clasice din anii 2000.
            Retrăiește diminețile lungi de sâmbătă.
          </p>
        </div>
        <div>
          <div className="font-display text-pink-400 font-black uppercase text-sm mb-3 tracking-widest">Canale</div>
          <ul className="grid grid-cols-2 gap-x-6 gap-y-1 text-white/80 text-sm">
            <li>Cartoon Network</li>
            <li>Kids Co.</li>
            <li>Nickelodeon</li>
            <li>MiniMax</li>
            <li>Fox Kids</li>
            <li>Boomerang</li>
            <li>Jetix</li>
          </ul>
        </div>
        <div>
          <div className="font-display text-yellow-300 font-black uppercase text-sm mb-3 tracking-widest">Legal</div>
          <ul className="space-y-1 text-white/80 text-sm">
            <li>
              <Link
                to="/disclaimer"
                data-testid="footer-disclaimer-link"
                className="hover:text-pink-400 transition-colors underline-offset-4 hover:underline"
              >
                Termeni și Condiții
              </Link>
            </li>
            <li>
              <Link
                to="/confidentialitate"
                data-testid="footer-privacy-link"
                className="hover:text-pink-400 transition-colors underline-offset-4 hover:underline"
              >
                Politică de Confidențialitate (GDPR)
              </Link>
            </li>
          </ul>
        </div>
        <div className="flex md:justify-end items-start">
          <div className="font-pixel text-yellow-300 text-2xl">© 1990 - 2012</div>
        </div>
      </div>
      <div className="border-t-2 border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 text-center text-white/60 text-xs font-bold">
          © 2026 Desene2000. Toate drepturile rezervate.
        </div>
      </div>
    </footer>
  );
}
